function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "8110akwe0a",
  d: "M14.071 16.787c.378 0 .63.253.63.63-.126 1.387-1.26 2.583-2.709 2.583-1.385 0-2.582-1.134-2.582-2.583 0-.315.252-.63.63-.63s.63.253.63.63c0 .757.63 1.387 1.385 1.387.756 0 1.386-.63 1.386-1.387 0-.315.252-.63.63-.63zM12.181 4c2.71.063 4.85 2.268 4.85 5.04v4.41c0 .691 1.072 1.385 1.828 1.385.315 0 .63.251.63.63 0 .378-.252.566-.63.566H5.629c-.314 0-.629-.251-.629-.63 0-.377.252-.63.63-.63.756 0 1.386-.63 1.386-1.386V9.04c0-2.772 2.268-5.04 5.04-5.04h.125zm-.063 1.197h-.126C9.914 5.26 8.15 6.96 8.15 9.04v4.41c0 .503-.126 1.006-.378 1.385h8.567c-.315-.379-.504-.882-.504-1.386V9.04c0-2.078-1.638-3.716-3.717-3.842z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1200 -28) translate(1200 20) translate(0 8)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "21akleiahb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8110akwe0a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#8110akwe0a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#21akleiahb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "matrix(1 0 0 -1 0 24)"
}))))));

function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.8f43d93f.svg";
export { ForwardRef as ReactComponent };